import {
  EStatus,
  IFilterPikNewbuildingsResponse,
  IFilterPikNewbuildingsResponse200,
  IFilterPikNewbuildingsResponse400,
  IFilterPikNewbuildingsResponseError,
} from '../repositories/monolith-python/v1/filter-pik-newbuildings';

export function mapNewBuildingIdsResponse(response: IFilterPikNewbuildingsResponse): IFilterPikNewbuildingsResponse200 {
  return {
    statusCode: 200,
    headers: [],
    response: {
      status: EStatus.Ok,
      data: {
        newbuildingIds: response.data.newbuildingIds || [],
      },
    },
  };
}

export function mapNewBuildingIdsResponseError(
  response: IFilterPikNewbuildingsResponseError,
): IFilterPikNewbuildingsResponse400 {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
}
